import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { forwardRef } from 'react';
import { getButtonStyles, getButtonElementProps, } from '@cb/solaris-react/Components/Interactive/Button/ButtonHelpers';
const StyledRouterLink = styled(Link) `
	${(props) => getButtonStyles(props.$buttonProps, props.theme)}
	text-decoration: none;
`;
const RouterLink = forwardRef((props, ref) => {
    const elementProps = getButtonElementProps(props, ref);
    const filteredElementProps = {
        ...elementProps,
    };
    delete filteredElementProps.$buttonProps;
    return _jsx(StyledRouterLink, { ...filteredElementProps, "$buttonProps": elementProps.$buttonProps });
});
RouterLink.displayName = 'RouterLink';
export default RouterLink;
export const isRouterLinkProps = (props) => {
    return typeof props === 'object' && props !== null && 'to' in props;
};
//# sourceMappingURL=RouterLink.js.map